import {EventEmitter} from 'events';

class GlobalEmitter extends EventEmitter{
    constructor(){
        super();
        this.CHANGE_LANGUAGE = 'change_language';
        this.CHANGE_FONT = 'change_font';
        this.LOADING = 'loading';
        this.END_LOADING = 'end_loading';
        this.UPDATE_LOADING_STATUS = 'update_loading_status';
        this.OPEN_IMAGE_PICKER = 'open_image_picker';
        this.OPEN_CROPPER = 'open_cropper';
    }
}

export default new GlobalEmitter();


// WEBPACK FOOTER //
// ./src/GlobalEmitter.js